<template>
  <div class="agreement-page">
    <div class="agreement-page-inner">
      <h1 class="agreement-page-title">用户协议</h1>
      <AgreementContent type="userinfo" title="用户协议" />
    </div>
  </div>
</template>

<script>
import AgreementContent from "@/components/AgreementContent.vue";

export default {
  name: "UserAgreementPage",
  components: {
    AgreementContent,
  },
};
</script>
